export default __webpack_public_path__ + "static/media/CHZ.643b6059.svg";